<template>
  <div v-if="username && renderComponent">
    <div @click="toggleDropdown"> {{username}} </div>
    <div class="dropdown" v-show="showDropdownOptions">
      <div class="dropdownItem" v-on:click="toggleDropdown()">
        <router-link to="/user-settings" class="bar-item subitem"> <font-awesome-icon icon="cog" /> settings </router-link>
      </div>
      <div class="dropdownItem" v-if="uberUser" v-on:click="toggleDropdown()">
        <router-link to="/management" class="bar-item subitem"> <font-awesome-icon icon="heartbeat" /> management </router-link>
      </div>
      <div class="dropdownItem" v-on:click="toggleDropdown()">      
        <router-link class="dropdownItem bar-item subitem" to="/donate">
          <font-awesome-icon icon="heart"/> 
          {{$t('info.donate.header')}} 
        </router-link>
      </div>
      <div v-on:click="toggleDropdown()">      
        <div class="bar-item subitem" @click="logout">
          <font-awesome-icon icon="sign-out-alt"/> 
          {{$t('app.menu.logout')}} 
        </div>
      </div>
    </div>
  </div>
  <div v-else @click="login">
    <font-awesome-icon icon="sign-in-alt"/>
    {{$t('app.menu.login')}}
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const myInit = { 
  response: false,
};

export default {
  name: 'User',
  data: function() {
    return {
      renderComponent: true,
      showingDropdownOptions: false,
      user: null
    }
  },
  mounted() {
    console.log("mounting user component");
    if (this.$CAUser != null) {
      this.user = this.$CAUser.getChessUser();
    }
  },
  created() {
    this.$CAUser.setCallbackUserComponent(this);
  },
  computed: {
    uberUser: function() {
      console.log("uber?: " + this.$CAUser.getChessUser().login);
      console.log("uber2?: " + process.env.VUE_APP_UBER);
      return (process.env.VUE_APP_UBER == this.$CAUser.getChessUser().login)
    },
    username: function () {
      console.log("Determining username: '" + this.$CAUser + "'")
      if (this.$CAUser != null) {
        if (this.$CAUser != "")   
          return this.$CAUser.userName();
        else 
          return null;  
      } else
        return null;
    },
    showDropdownOptions: function() {
      console.log("showingoptions returned " + this.showingDropdownOptions)
      return this.showingDropdownOptions;
    },
  },
  methods: {
    findCA_UserByUniqueID: function (uniqueId) {
      let path = "/person?clubId=-1&uniqueId=" + uniqueId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          var users = response;
          console.log("User on uniqueId: " + JSON.stringify(users));
          if (users.length == 1) {
            this.$CAUser.setChessUser(users[0]);
            console.log("Setting Chess Userin findCA_UserByUniqueID to: " + JSON.stringify(users[0]));
          } else {
            //TODO: offer to couple account every once in a while
            this.$router.push("/select-user/")
          }
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    login() {
      this.$router.push("/sign-in");
    },
    
    logout() {
      this.$CAUser.logout();
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$router.push("/");
    },

    toggleDropdown() {
      this.showingDropdownOptions = !this.showingDropdownOptions;
    }    
  }
}

</script>

<style scoped>
  .dropdown {
    position: absolute;
    top: 34px;
    overflow: hidden;
    display: flex;
    right: 0;
    flex-direction: column;
  }

  .dropdownItem {
    text-align: justify;
    width: auto;
  }

  .subitem {
    z-index:1;
  }

</style>
